import React, { Fragment } from "react";
import Sticky from "react-stickynode";
import { ThemeProvider } from "styled-components";
import { interiorTheme } from "common/theme/interior";
import { DrawerProvider } from "common/contexts/DrawerContext";
import Navbar from "containers/Interior/Navbar";
import Footer from "containers/Interior/Footer";
import Heading from "common/components/Heading";
import { ResetCSS } from "common/assets/css/style";
import posta from "common/assets/image/interior/posta.jpg";
import {
  GlobalStyle,
  InteriorWrapper,
  ContentWrapper,
  BodyWrapper,
} from "containers/Interior/interior.style";
import SEO from "components/seo";

export default () => {
  return (
    <ThemeProvider theme={interiorTheme}>
      <Fragment>
        <SEO title="Partnership with Pošta Slovenije" />
        <ResetCSS />
        <GlobalStyle />

        {/* Start writing your markup from here. */}
        <InteriorWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <ContentWrapper>
            <BodyWrapper>
              <a href="/newsroom" style={{ color: "#00A5C0" }}>
                <Heading as="h5" content="NEWSROOM" />
              </a>
              <Heading as="h1" content="Partnership with Pošta Slovenije" />

              <p>
                <b>
                  Direct4me and Pošta Slovenije announced strategic partnership
                </b>
              </p>

              <p>
                Direct4me and Pošta Slovenije are pleased to announce their
                strategic partnership. They combine Direct4me’s innovative
                parcel delivery solution with Pošta Slovenije (Post of Slovenia)
                last-mile service to improve pick-up and drop-off options.
              </p>

              <p>
                <b>
                  The partnership of Direct4me and Pošta Slovenije is a powerful
                  combination
                </b>
              </p>

              <p>
                Pošta Slovenija is a successful company wholly owned by the
                Republic of Slovenia. With its nearly 5,500 employees, it plays
                play an important role in the Slovenian market. As a universal
                postal service provider, they guarantee access to postal
                services within the framework of legal requirements. Pošta
                Slovenije also plays a key role in formulating the legal basis
                for ensuring non-discriminatory operating conditions and
                ensuring the highest quality standards for the postal network
                and the market for universal postal, logistics and other
                services. Direct4me's understanding of the complexity of pick-up
                and drop-off user experiences, deep technical expertise,
                collaborative approach and proprietary technology (DOV - Data
                over Voice, which enables secure unlocking of spaces with a
                feature phone or even without registration) is unique addition
                to Pošta Slovenije’s vision for the future of its services.
              </p>

              <p>
                <b>Parcel pick-up in the Direct4me delivery space</b>
              </p>
              <img src={posta}/>

              <p>
                Fast contact-free parcel collection at more than 100 locations
                in Slovenia Pošta Slovenije is continuing with the planned
                modernisation and automation of its network. Users now have an
                easy and convenient way to pick up their parcels. The existing
                network of 24 parcel spaces in bigger cities in Slovenia will be
                complemented by 450 Direct4me smart parcel delivery spaces,
                installed at more than 113 locations across Slovenia. We believe
                that this partnership will accelerate the digital transformation
                of Pošta Slovenije from a provider of traditional postal
                services to a modern, development-oriented postal logistics
                operator and provider of electronic services. In addition,
                Direct4me will benefit greatly from Pošta Slovenije's large
                network and strong presence in the Slovenian last-mile delivery
                market.
              </p>
              
            </BodyWrapper>
          </ContentWrapper>
          <Footer />
        </InteriorWrapper>
        {/* End of markup section. */}
      </Fragment>
    </ThemeProvider>
  );
};
